import {Conversation} from '@stripe-internal/conversations-client';

import {
  messages,
  useConversationLogEventsForViewMode,
} from '../../StripeAssistant/hooks/useConversationLogEvents';
import {useThreadsViewMode, useThreadsWithHistory} from '../app/hooks';

export {messages};

export function useThreadsConversationLogEvents(conversation: Conversation) {
  const viewMode = useThreadsViewMode();
  const withHistory = useThreadsWithHistory();
  useConversationLogEventsForViewMode(conversation, viewMode, withHistory);
}
